import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
let MultiSelectComponent = class MultiSelectComponent {
    model = [];
    disabled;
    options;
    placeholder;
    optionLabel;
    styleClass;
    tooltip = '';
    tooltipPosition = '';
    modelChange = new EventEmitter();
    handleChange($event) {
        this.modelChange.emit($event.value);
    }
    static propDecorators = {
        model: [{ type: Input }],
        disabled: [{ type: Input }],
        options: [{ type: Input }],
        placeholder: [{ type: Input }],
        optionLabel: [{ type: Input }],
        styleClass: [{ type: Input }],
        tooltip: [{ type: Input }],
        tooltipPosition: [{ type: Input }],
        modelChange: [{ type: Output }]
    };
};
MultiSelectComponent = __decorate([
    Component({
        selector: 'multiSelect',
        encapsulation: ViewEncapsulation.None,
        template: `
  <p-multiSelect
    [disabled]="disabled"
    [placeholder]="placeholder"
    [options]="options" [(ngModel)]="model" [optionLabel]="optionLabel"
    display="chip"
    [tooltip]="tooltip"
    [tooltipPosition]="tooltipPosition"
    (onChange)="handleChange($event)">
  </p-multiSelect>
  `,
        styles: ["\n    .p-multiselect {\n      width: 100%\n    },\n    .p-multiselect-label {\n      display: block;\n      white-space: nowrap;\n      cursor: pointer;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  "]
    })
], MultiSelectComponent);
export { MultiSelectComponent };
